import { watch, ref, onMounted } from 'vue'
import { driver } from 'driver.js'
import { PRIVILEGES } from '../../../services/privileges';
import { OFFERS } from '../../../services/offers';
import { useStore } from 'vuex';

import 'driver.js/dist/driver.css'

export function useGuidedTour() {
  const store = useStore(); // Accéder au store Vuex
  const driverInstance = ref(null)
  const isActive = ref(false)

  var guidedTourSteps = [
    {
      element: '#user-details-icon',
      popover: {
        title: 'Page de profil',
        description: 'Personnalisez votre expérience',
        side: 'left',
        align: 'start'
      }
    },
    {
      element: '#rdv-link',
      popover: {
        title: 'Rendez-vous',
        description: 'Accéder à votre agenda ou celui de votre équipe.',
        side: 'right',
        align: 'start'
      }
    },
    {
      element: '#animals-link',
      popover: {
        title: 'Animaux',
        description: 'Gérez les animaux qui travaillent avec vous.',
        side: 'right',
        align: 'start'
      }
    },
    {
      element: '#places-link',
      popover: {
        title: 'Lieux',
        description: 'Les lieux sont les endroits où vous réalisez vos séances.',
        side: 'right',
        align: 'start'
      }
    },
    {
      element: '#patients-link',
      popover: {
        title: 'Patients',
        description: 'Gérez vos patients.',
        side: 'right',
        align: 'start'
      }
    },
    {
      element: '#bills-link',
      popover: {
        title: 'Facturation',
        description: 'Gérez vos factures.',
        side: 'right',
        align: 'start'
      }
    },
    {
      element: '#admin-link',
      popover: {
        title: 'Adminstration',
        description: 'Suivez les statistiques de votre activité.',
        side: 'right',
        align: 'start'
      }
    },
    {
      element: '#team-link',
      popover: {
        title: 'Votre équipe',
        description: 'Définissez les rôles des membres de votre équipe.',
        side: 'right',
        align: 'start'
      }
    }
  ];

  const initDriver = () => {
    driverInstance.value = driver({
      showProgress: true,
      steps: guidedTourSteps,
      nextBtnText: 'Suivant →',
      prevBtnText: '← Précédent',
      doneBtnText: 'Terminé ✓',
      styles: {
        popover: {
          footer: {
            backgroundColor: '#ffffff', 
            color: '#000000', 
          }
        }
      },
      onDestroyed: () => {
        isActive.value = false
      }
    })
    const isAdmin = store.getters.privileges.includes(PRIVILEGES.ADMINISTRATION);
    const getters = JSON.parse(JSON.stringify(store.getters))
    const offerName = getters.user.tenant.offer;
    const isNotOfferStandard = (offerName.toLocaleUpperCase() !== OFFERS.STANDARD.toString().toLocaleUpperCase());

    if (!isAdmin || !isNotOfferStandard) {
      guidedTourSteps = guidedTourSteps.filter((step) => step.element !== '#team-link');
    }
  
  }

  const startTour = () => {
    if (! driverInstance.value) {
        initDriver()
    }
    
    isActive.value = true
    driverInstance.value.drive()
  }

  const stopTour = () => {
    if (driverInstance.value) {
      driverInstance.value.destroy()
      isActive.value = false
    }
  }

  onMounted(async () => {
    const stopWatcher = watch(
      () => store.getters.user,
      (newUser) => {
        if (newUser && Object.keys(newUser).length > 0) {
          initDriver()
          stopWatcher() // Arrêter le watcher une fois initialisé
        }
      },
      { immediate: true } // Vérifier immédiatement
    )
  })

  return {
    startTour,
    stopTour,
    isActive,
    driverInstance
  }
}
